/**
 * Batch Import User Memberships - English Translation
 */
export const batchImportUserMembershipsEn = {
  // Dialog
  title: 'Batch Import User Memberships',
  dialogTitle: 'Batch Import User Memberships',
  
  // Steps
  steps: {
    title: 'Import Steps',
    step1: 'Download user membership import template',
    step2: 'Fill in user-department relationship information according to template format',
    step3: 'Upload the completed file',
    step4: 'Confirm and submit import',
  },
  
  // Template related
  template: {
    title: 'Template Instructions',
    downloadBtn: 'Download Template',
    downloading: 'Downloading...',
    downloaded: 'Template Downloaded',
    fields: {
      email: 'User Email',
      emailDesc: 'Required, used to find existing users',
      departmentCode: 'Department Code',
      departmentCodeDesc: 'Required, the department code the user belongs to',
      positionId: 'Position ID',
      positionIdDesc: 'Optional, user\'s position ID (UUID format)',
      managerEmail: 'Manager Email',
      managerEmailDesc: 'Optional, direct manager\'s email address',
      title: 'Department Title',
      titleDesc: 'Optional, user\'s title in this department',
      isPrimary: 'Is Primary',
      isPrimaryDesc: 'Optional, fill true or false, default false',
    },
    autoCodeTip: '💡 Tip: Users must already exist in the system (created via Entra ID sync), this function only imports user-department relationships',
  },

  // Upload related
  upload: {
    title: 'Upload File',
    required: 'Upload File *',
    placeholder: 'Click to select file or drag file here',
    reselect: 'Click to reselect file',
    formatHint: 'Supports .xlsx, .xls formats',
    parsing: 'Parsing...',
    parseSuccess: 'File parsed successfully, {count} valid records',
    parseWarning: 'File parsed with {count} invalid records',
    parseFailed: 'Failed to parse file, please check file format',
  },

  // Table
  table: {
    email: 'User Email',
    departmentCode: 'Department Code',
    managerEmail: 'Manager Email',
    title: 'Title',
    isPrimary: 'Primary',
    error: 'Error',
    yes: 'Yes',
    no: 'No',
    empty: '-',
  },

  // Data validation
  validation: {
    validData: 'Valid Data',
    invalidData: 'Invalid Data',
    dataCount: '{count} items',
    errorReasons: {
      missingRequired: 'Missing required fields (email or department code)',
      invalidEmailFormat: 'Invalid email format',
      invalidDepartmentCode: 'Invalid department code format',
    },
  },

  // Actions
  actions: {
    cancel: 'Cancel',
    confirm: 'Start Import',
    confirmWithCount: 'Start Import ({count} items)',
    importing: 'Importing...',
  },

  // Messages
  messages: {
    noValidData: 'No valid data to import',
    importSuccess: 'Successfully imported {count} memberships',
    importFailed: 'Import failed, please try again later',
    importPartial: 'Import completed: {success} succeeded, {failed} failed',
    userNotFound: 'User not found: {email}',
    departmentNotFound: 'Department not found: {code}',
    managerNotFound: 'Manager not found: {email}',
  },
};


